import type { CtaData } from '@fiverr-private/business_success_sign_modal';

/** @deprecated */
export interface OpenFibMigrationEventDetails {
    withSkipAction: boolean;
    biEnrichment: unknown;
    redirectCtaData?: CtaData;
    onSuccess: () => void;
    onError: () => void;
    onLoadError: (err?: unknown) => void;
    onSkip: () => void;
    source: string;
}

type OptionalFields = 'withSkipAction' | 'redirectCtaData' | 'onSuccess' | 'onError' | 'onLoadError' | 'onSkip';

/** @deprecated */
export interface OpenFibMigrationEventPayload
    extends Omit<OpenFibMigrationEventDetails, OptionalFields>,
        Partial<Pick<OpenFibMigrationEventDetails, OptionalFields>> {}

/** @deprecated - Using only to support call from builder.io */
export type OpenFibMigrationEvent = CustomEvent<OpenFibMigrationEventPayload & { source: string; isOpen?: boolean }>;

export const DEPRECATED_EVENT_NAME = 'openFibMigration';

export const setupEventHandler = (handler) => addEventListener(DEPRECATED_EVENT_NAME, handler);

export const removeEventHandler = (handler) => removeEventListener(DEPRECATED_EVENT_NAME, handler);
